import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { VIRTUAL_CARD } from 'src/environments/environment';

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss']
})
export class ModalConfirmationComponent implements OnInit, OnDestroy {
  @Input() type: string;
  @Input() content: any;
  @Input() loading = false;
  @Input() guestCard: boolean;
  @Input() errorReadingCard = '';
  @Input() cardType: string;
  @Input() burgRooms: Controller[] = [];
  @Output() decision: EventEmitter<boolean> = new EventEmitter();
  @Output() createVirtualCard: EventEmitter<string> = new EventEmitter();

  VIRTUAL_CARD = VIRTUAL_CARD;
  constructor() { }

  ngOnInit(): void {
  }

  decisionClick(choice: boolean) {
    this.decision.emit(choice);
  }

  onClickCreateVirtualCard() {
    this.createVirtualCard.next(null)
  }

  generateRandomNumber(size: number): number {
    const min = Math.pow(10, size - 1);
    const max = Math.pow(10, size) - 1;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  ngOnDestroy() {
  }
}
